import { Result } from 'antd';
import type { ReactNode } from 'react';
import { useAuth } from '../auth/AuthContext';

export function RequirePerm({ perm, children }: { perm: string; children: ReactNode }) {
  const { can } = useAuth();
  if (!can(perm)) return <Result status="403" title="Access denied" subTitle="You do not have permission to view this page." />;
  return <>{children}</>;
}
